import React, { useEffect, useState } from "react";
import { useMotionValueEvent } from "framer-motion";
import ThemeToggle from "../ThemeToggle";
import { useCamera } from "./CameraProvider";
import { useFlyToSection } from "./BoardGeometry";
import { MAP } from "../../utils/mapCamera";
import { SECTIONS, SECTION_ORDER } from "../../data/board";
import { profile } from "../../data/profile";

export const BoardHud = () => {
  const { resetView, showWholeBoard, zoomBy, scale } = useCamera();
  const flyToSection = useFlyToSection();
  const [zoomPct, setZoomPct] = useState(() => Math.round(scale.get() * 100));

  const [hintRead, setHintRead] = useState(false);

  // The hint has done its job once the visitor starts moving the board.
  useEffect(() => {
    if (hintRead) return undefined;
    const dismiss = () => setHintRead(true);
    window.addEventListener("pointerdown", dismiss, { once: true, passive: true });
    window.addEventListener("wheel", dismiss, { once: true, passive: true });
    return () => {
      window.removeEventListener("pointerdown", dismiss);
      window.removeEventListener("wheel", dismiss);
    };
  }, [hintRead]);

  useMotionValueEvent(scale, "change", (value) => {
    setZoomPct(Math.round(value * 100));
  });

  return (
    <div className="board-hud">
      <header className="board-hud-top">
        <button type="button" className="board-case-tab" onClick={() => resetView(true)} aria-label="Back to the subject file">
          <span className="board-case-tab-no">{profile.caseNumber}</span>
          <span className="board-case-tab-name">{profile.displayName}</span>
          <span className="board-case-tab-title">{profile.title}</span>
        </button>

        <nav className="board-index" aria-label="Case index">
          {SECTION_ORDER.map((id) => (
            <button key={id} type="button" className="board-index-item" onClick={() => flyToSection(id)}>
              <span className="board-index-no">{SECTIONS[id].number}</span>
              {SECTIONS[id].nav}
            </button>
          ))}
        </nav>

        <div className="board-hud-actions">
          <div className="board-zoom-control" role="group" aria-label="Board zoom">
            <button type="button" className="board-zoom-btn" onClick={() => zoomBy(1 / MAP.zoomStep)} aria-label="Zoom out">
              −
            </button>
            <button
              type="button"
              className="board-zoom-level"
              onClick={() => resetView(true)}
              aria-label={`Zoom ${zoomPct} percent. Reset view`}
            >
              {zoomPct}%
            </button>
            <button type="button" className="board-zoom-btn" onClick={() => zoomBy(MAP.zoomStep)} aria-label="Zoom in">
              +
            </button>
          </div>
          <button type="button" className="board-reset" onClick={() => showWholeBoard(true)}>
            Whole board
          </button>
          <ThemeToggle />
        </div>
      </header>
      <p className={`board-hint${hintRead ? " is-read" : ""}`} aria-hidden={hintRead}>Drag to pan · Scroll or pinch to zoom · Hover a card to trace its strings</p>
    </div>
  );
};

export default BoardHud;
